var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof copilot_chat_ui !== "undefined") return resolve();
	__webpack_require__.l("https://assets.mindtickle.com/copilot-chat-ui/ux-refresh-prod-ldr/production/remoteEntry.js", function(event) {
		if(typeof copilot_chat_ui !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "copilot_chat_ui");
}).then(function() { return copilot_chat_ui; });